@if (organisationService.actingAsAdministrator()) {
  <div class="acting-banner" role="status" data-testid="acting-org-banner">
    <span class="acting-banner__text">
      Acting in {{ organisationService.activeOrgName() ?? 'another organisation' }} as a Finxone administrator
    </span>
    @if (canReturnHome) {
      <button type="button" class="acting-banner__action" (click)="returnHome()" data-testid="acting-org-banner-return">
        Back to my organisation
      </button>
    }
  </div>
}
